import { JSConn } from "@/utilities/js-conn";
import Big from "big.js";

export interface BaleYardLot {
  calc_pounds_per_unit: Big;
  calc_price: Big;
  calc_quantity: Big;
  description: string;
  id: string;
  lot_unit: string;
  lot_unit_id: string;
  pounds_per_unit: number;
  price: number;
  quantity: number;
}

interface BaleYardLotState {
  baleYardLots: BaleYardLot[];
  baleYardLot: BaleYardLot | {};
}

const state: BaleYardLotState = {
  baleYardLots: [],
  baleYardLot: {},
};

const mutations = {
  LOAD_BALE_YARD_LOT(state: BaleYardLotState, payload: BaleYardLot) {
    state.baleYardLot = payload;
  },
  LOAD_BALE_YARD_LOTS(state: BaleYardLotState, payload: BaleYardLot[]) {
    state.baleYardLots = payload;
  },
};

const actions = {
  needBaleYardLots(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return new Promise((resolve, _reject) => {
      // when these items are loaded from the api, they
      // will need to set the calc numbers correctly
      // converting the data to bigs
      const baleYardLots: BaleYardLot[] = [
        {
          calc_pounds_per_unit: new Big(2412),
          calc_price: new Big(120),
          calc_quantity: new Big(112),
          description: "Lot #120",
          id: "34eeb44a-c7a2-411a-b3b0-a7371ad3382c",
          lot_unit: "Large sqares",
          lot_unit_id: "0c6fb9fb-af98-467f-9fd0-ffb07374dfbe",
          pounds_per_unit: 2412,
          price: 120.0,
          quantity: 112,
        },
        {
          calc_pounds_per_unit: new Big(2612),
          calc_price: new Big(130),
          calc_quantity: new Big(234),
          description: "Lot #130",
          id: "a6ec77cf-5ff0-403c-b3cb-9d1968853cf0",
          lot_unit: "Large sqares",
          lot_unit_id: "0c6fb9fb-af98-467f-9fd0-ffb07374dfbe",
          pounds_per_unit: 2612,
          price: 130.0,
          quantity: 234,
        },
        {
          calc_pounds_per_unit: new Big(2112),
          calc_price: new Big(140),
          calc_quantity: new Big(134),
          description: "Lot #140",
          id: "2d3b5739-b623-4da1-b3b5-1fef25d18605",
          lot_unit: "Large sqares",
          lot_unit_id: "0c6fb9fb-af98-467f-9fd0-ffb07374dfbe",
          pounds_per_unit: 2112,
          price: 140.0,
          quantity: 134,
        },
      ];
      context.commit("LOAD_BALE_YARD_LOTS", baleYardLots);
      resolve(jsConn);
    });
  },
};

const getters = {
  baleYardLots: (state: BaleYardLotState) => state.baleYardLots,
};

const baleYardLotsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default baleYardLotsModule;
